const CommonDropdown = ({
    label,
    options = [],
    value,
    onChange,
    placeholder = "Select",
    error,
    disabled = false,
}) => {
    return (
        <div className="dropdown-wrapper">
            {label && <label>{label}</label>}

            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                className="form-select"
            >
                <option value="">{placeholder}</option>
                {options.map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </select>

            {error && <p className="error-text">{error}</p>}
        </div>
    );
};

export default CommonDropdown;